<template>
  <div class="SettingsPage">
    <div
    v-if="false"
    class="SettingsPage__category">
      <div class="SettingsPage__title">
        Notifications
      </div>
      <div class="SettingsPage__cell">
        <el-checkbox
        class="SettingsPage__checkbox"
        v-model="notificationEnabled">
          Show Notifications
        </el-checkbox>
      </div>
    </div>
    <div class="SettingsPage__category">
      <div class="SettingsPage__title">
        Help
      </div>
      <div class="SettingsPage__cell">
        <a
        href="https://www.kingsch.at/h/privacy.pdf" target="_blank" rel="noopener noreferrer"
        class="SettingsPage__link">
          Terms and Conditions
        </a>
      </div>
      <div class="SettingsPage__cell">
        <a
        href="https://kingschatforum.com/t/faq" target="_blank" rel="noopener noreferrer"
        class="SettingsPage__link">
          FAQ
        </a>
      </div>
      <div class="SettingsPage__cell">
        <a
        href="https://www.kingsch.at/h/cloud.html" target="_blank" rel="noopener noreferrer"
        class="SettingsPage__link">
          About
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SettingsPage',

  computed: {
    ...mapGetters('notifications', [
      'enabled'
    ]),
    notificationEnabled: {
      get () {
        return this.enabled
      },
      set (value) {
        this.setEnabled(value)
      }
    }
  },

  methods: {
    ...mapActions('notifications', [
      'setEnabled'
    ])
  }
}
</script>

<style lang="scss">
@import 'SettingsPage';
</style>
